import {Component, AfterViewInit, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'rxjs/Rx';
import {NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import {__moduleName, CanDeactivateGuard} from '../../interfaces';

import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { UserUrl } from '../../shared/urls/user.url';
import { Utility } from '../../common/utility';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';
import { CreatePasswordModel } from '../../models/create-password/create-password.model';
import { AuthService } from "../../shared/services/auth.service";

@Component({
  moduleId: __moduleName,
  selector: 'create-password',
  templateUrl: 'create-password.component.html',
})

export class CreatePasswordComponent implements OnInit, AfterViewInit {
  public isHiddenSpinner = true;
  public createPassForm: FormGroup;
  private userid: string;
  public createPasswordModel = new CreatePasswordModel('', '', '');

  constructor(private formBuilder: FormBuilder,
              public utility: Utility,
              private activeRouter: ActivatedRoute,
              private router: Router,
              private baseService: BaseService,
              private authService: AuthService,
              public dialogService: DialogService) {

  }

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit() {

  }
  createForm(){
    this.userid = this.activeRouter.snapshot.params['id'];

    this.createPassForm = this.formBuilder.group({
      UserId: this.userid,
      SecurityCode: ['', [Validators.required]],
      NewPassword: ['', [Validators.required, this.isValidNewPassword]],
      ConfirmPassword: ['', [Validators.required, this.isValidRePassword]],
    });
  }

  isValidNewPassword (control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let newPass = group.controls['NewPassword'].value;
      // if (group.controls['OldPassword'].value === newPass) {
      //   return { 'newPassSameOldPass': true };
      // }
      let pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[!@#$%^&*()_+\d])[A-Za-z\d!@#$%^&*()_+]{8,128}$/;
      if (!pattern.test(newPass)) {
        return { 'invalidPassPolicy': true };
      }
    }
    return null;
  }

  isValidRePassword(control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let rePass = group.controls['ConfirmPassword'].value;
      if (group.controls['NewPassword'].value !== rePass) {
        return { 'newPassNotMatchConfirmPass': true };
      }
    }
    return null;
  }

  resetFormData (ngForm) {
    ngForm.resetForm();
    this.createPassForm.reset();
  }

  onSubmit(ngForm) {
    if (this.createPassForm.dirty && this.createPassForm.valid) {
      console.log('success: ' + this.createPassForm.value);
      let url = UserUrl.CREATE_PASSWORD;

      this.isHiddenSpinner = false;
      this.baseService.postData(url, this.createPassForm.value).subscribe(
        (result) => {
          if (result) {
            if (result) {
              const data = result.json();
              var type = data['type']
              if(type=='InvalidSecurityCode')
              {
              //  this.resetFormData(ngForm);
                this.dialogService.openSuccessDialog({message: data.message});
              }
              else if(type=='ValidSecurityCode')
              {
                this.authService
                .login({
                  UserName: data.user.userName,
                  Password: data.user.password
                })
                .subscribe(
                  (result) => {
                    this.isHiddenSpinner = true;
                    this.router.navigate(['/home']);
                  }, error => {
                    this.isHiddenSpinner = true;
                  });
              }
            }
          }
        },
          error => {
            this.isHiddenSpinner = true;
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/create-password/create-password.component.ts